import styled from 'styled-components';

import { ArrowIcon } from 'app/theme/Icons/ArrowIcon';

interface TimeChangerProps {
  time: string | number;
  addTime: () => void;
  subTime: () => void;
}

const Container = styled.div`
  margin: -1rem 0.75rem;
  display: flex;
  align-items: center;
  flex-direction: column;
  min-width: 3.5rem;
`;

const TimeContainer = styled.strong`
  font-size: 2.2rem;
  margin: 1rem 0;
`;

const DownIcon = styled(ArrowIcon)`
  transform: rotate(180deg);
`;

const IconButton = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  transition: 0.2s transform;
  margin: 1rem 0;

  &:hover {
    transform: scale(1.2);
  }

  &:focus {
    outline: none;
  }
`;

export const TimeChanger = ({ addTime, subTime, time }: TimeChangerProps): JSX.Element => (
  <Container>
    <IconButton aria-label="Add time" type="button">
      <ArrowIcon onClick={addTime} />
    </IconButton>
    <TimeContainer>{time}</TimeContainer>
    <IconButton aria-label="Sub time" type="button">
      <DownIcon onClick={subTime} />
    </IconButton>
  </Container>
);
